export default {
    name: 'QPill',
    props: {
        color: {
            type: String,
            default: 'gray-0'
        },
        // round or square
        shape: {
            type: String,
            default: 'round'
        },
        // Added this prop to give the flexibility to change color for contrast purposes
        textColor: {
            type: String,
            default: 'inkwell-30'
        },
        icon: {
            type: String,
            default: ''
        },
        url: {
            type: String,
            default: ''
        }
    }
};
